// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';

// Bootstrap
import {
  Button,
  Grid
} from 'react-bootstrap';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './CookiesDisclaimer.css';
import bt from '../../components/commonStyle.css';

// Locale
import { getCookies, setCookies } from '../../helpers/cookies';
import messages from '../../locale/messages';

import Link from '../Link';

class CookiesDisclaimer extends Component {

  static propTypes = {
    formatMessage: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isCookiesSet: false,
      isPageLoad: false,
    }
  }

  UNSAFE_componentWillMount() {
    const cookiesValue = getCookies({ name: 'cookiesDisclaimer' });
    this.setState({
      isCookiesSet: (cookiesValue) ? true : false
    });
  }

  componentDidMount() {
    const cookiesValue = getCookies({ name: 'cookiesDisclaimer' });
    this.setState({
      isCookiesSet: (cookiesValue) ? true : false,
      isPageLoad: true
    });
  }

  disclaimerForm = () => {
    setCookies({
      name: 'cookiesDisclaimer',
      value: 'RentallDisclaimer',
      options: {
        path: '/', maxAge: 3650 * 24 * 365
      }
    });
    this.setState({ isCookiesSet: true })
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { isCookiesSet, isPageLoad } = this.state;
    const { siteName } = this.props;

    if (isCookiesSet) {
      return <div></div>;
    } else {
      return (
        <Grid fluid>
          {
            isPageLoad && <div
              className={cx(s.root, s.container, s.fixedPosition)}
            >
              <div className={cx(s.cookiesBackground)}>
                <div>
                  <div className={cx(s.displayTable, s.displayTableSection)}>
                    <div className={s.displayRow}>
                      <div className={s.displayText}>
                        <span className={cx(s.labelText)}>
                          {siteName}{' '}
                          {formatMessage(messages.cookiesDisclaimer)}
                          {' '}
                          <Link to={'/cookie-policy'} className={cx(s.labelText, s.linkStyle)}>{formatMessage(messages.cookiePolicy)}</Link>
                        </span>
                      </div>

                      <div className={cx(s.displayBtn)}>
                        <Button
                          type="button"
                          className={cx(s.button, bt.btnPrimary, bt.btnLarge, 'cookiBtn')}
                          onClick={this.disclaimerForm}
                        >
                          {formatMessage(messages.gotIt)}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          }
        </Grid>
      )
    }
  }
}

const mapState = state => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
)(CookiesDisclaimer);
